import React, { useContext } from 'react'
import { Settings } from '../contexts/Settings';
import { Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Timeline } from '@mui/icons-material';

function Sidebar() {
    const { clickDropMenu } = useContext(Settings);
    const { logOut } = useContext(AuthContext);
    return (
        <aside className="app-sidebar sticky" id="sidebar">
            {/* Start::main-sidebar-header */}
            <div className="main-sidebar-header">
                <Link to="/" className="header-logo">
                    <img src="https://elnaf.fi/assets/img/logo/ElnafLogo.svg" alt="logo" className="desktop-logo" />
                    <img src="https://elnaf.fi/assets/img/logo/ElnafLogo.svg" alt="logo" className="toggle-dark" />
                    <img src="https://elnaf.fi/assets/img/logo/ElnafLogo.svg" alt="logo" className="desktop-dark" />
                    <img src="https://elnaf.fi/assets/img/logo/ElnafLogo.svg" alt="logo" className="toggle-logo" />
                </Link>
            </div>
            {/* End::main-sidebar-header */}
            {/* Start::main-sidebar */}
            <div className="main-sidebar" id="sidebar-scroll">
                {/* Start::nav */}
                <nav className="main-menu-container nav nav-pills flex-column sub-open">
                    <div className="slide-left" id="slide-left">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width={24} height={24} viewBox="0 0 24 24"> <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" /> </svg>
                    </div>
                    <ul className="main-menu">
                        {/* Start::slide__category */}
                        <li className="slide__category"><span className="category-name">Elnaf Dashboard</span></li>
                        {/* End::slide__category */}
                        {/* Start::slide */}
                        <li className="slide" onClick={clickDropMenu}>
                            <Link to="/" className="side-menu__item">
                                <svg xmlns="http://www.w3.org/2000/svg" className="side-menu__icon" viewBox="0 0 256 256"><rect width={256} height={256} fill="none" /><path d="M104,216V152h48v64h64V120a8,8,0,0,0-2.34-5.66l-80-80a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,40,120v96Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} /></svg>
                                <span className="side-menu__label">Dashboard</span>
                            </Link>
                        </li>
                        {/* End::slide */}
                        {/* Start::slide__category */}
                        <li className="slide__category"><span className="category-name">Web Apps</span></li>
                        {/* End::slide__category */}
                        {/* Start::slide */}
                        <li className="slide has-sub" onClick={clickDropMenu}>
                            <a href="" className="side-menu__item">
                                <svg xmlns="http://www.w3.org/2000/svg" className="side-menu__icon" viewBox="0 0 256 256"><rect width={256} height={256} fill="none" /><rect x={48} y={48} width={64} height={64} rx={8} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} /><rect x={144} y={48} width={64} height={64} rx={8} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} /><rect x={48} y={144} width={64} height={64} rx={8} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} /><rect x={144} y={144} width={64} height={64} rx={8} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} /></svg>
                                <span className="side-menu__label">Apps</span>
                                <i className="ri-arrow-right-s-line side-menu__angle" />
                            </a>
                            <ul className="slide-menu child1">
                                <li className="slide">
                                    <Link to="/products" className="side-menu__item">Products</Link>
                                </li>
                                <li className="slide">
                                    <Link to="/add-product" className="side-menu__item">Add Product</Link>
                                </li>
                                <li className="slide">
                                    <Link to="/orders" className="side-menu__item">Orders</Link>
                                </li>
                                <li className="slide">
                                    <Link to="/categories" className="side-menu__item">Categories</Link>
                                </li>
                                <li className="slide">
                                    <Link to="/banners" className="side-menu__item">Banners</Link>
                                </li>
                                <li className="slide">
                                    <Link to="/site-content" className="side-menu__item">Site Content</Link>
                                </li>
                                <li className="slide">
                                    <Link to="/long-descriptions" className="side-menu__item">Long Descriptions</Link>
                                </li>
                                <li className="slide">
                                    <Link to="/campaigns" className="side-menu__item">Campaigns</Link>
                                </li>
                                <li className="slide">
                                    <Link to="/product-images" className="side-menu__item">Product Images</Link>
                                </li>
                                <li className="slide">
                                    <Link to="/seo-settings" className="side-menu__item">SEO Settings</Link>
                                </li>
                                <li className="slide">
                                    <Link to="/blog-posts" className="side-menu__item">Blog Posts</Link>
                                </li>
                            </ul>
                        </li>
                        {/* End::slide */}

                        {/* Start::slide */}
                        <li className="slide has-sub" onClick={clickDropMenu}>
                            <a href="" className="side-menu__item">
                                <svg xmlns="http://www.w3.org/2000/svg" className="side-menu__icon" viewBox="0 0 256 256"><rect width={256} height={256} fill="none" /><rect x={40} y={88} width={176} height={128} rx={8} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} /><circle cx={128} cy={152} r={12} /><path d="M88,88V56a40,40,0,0,1,80,0V88" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} /></svg>
                                <span className="side-menu__label">Authentication</span>
                                <i className="ri-arrow-right-s-line side-menu__angle" />
                            </a>
                            <ul className="slide-menu child1">
                                <li className="slide">
                                    <Link to="/profile" className="side-menu__item">Account</Link>
                                </li>
                                <li className="slide">
                                    <button onClick={logOut} className="side-menu__item">Log Out</button>
                                </li>
                            </ul>
                        </li>
                        {/* End::slide */}
                        {/* Start::slide */}
                        <li className="slide" onClick={clickDropMenu}>
                            <Link to="/timeline" className="side-menu__item">
                                <Timeline />
                                <span className="side-menu__label">Timeline</span>
                            </Link>
                        </li>
                        {/* End::slide */}
                    </ul>
                    <div className="slide-right" id="slide-right"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width={24} height={24} viewBox="0 0 24 24"> <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" /> </svg></div>
                </nav>
                {/* End::nav */}
            </div>
            {/* End::main-sidebar */}
        </aside>
    )
}

export default Sidebar